<template>
  <div>
    <v-toolbar flat>
      <v-toolbar-title>{{ $t(`headings.${$route.name}`) }}</v-toolbar-title>
      <v-spacer> </v-spacer>
      <v-btn @click="handleOpenDialog" class="primary mx-2">
        <v-icon small left>mdi-plus</v-icon>
        <span>{{ $t("button.create") }}</span>
      </v-btn>
    </v-toolbar>
    <!-- table -->
    <v-row no-gutters>
      <v-col cols="12" sm="2" class="toggle-spacing toggle-adjust">
        <global-toggle-filter
          :queries="toggleQueries"
          ref="toggle_filter_ref"
          class="mt-2"
        />
      </v-col>
    </v-row>
    <wrapping-table
      @on_dialog_close="onDialogClose"
      ref="table_ref"
      :headersName="headers"
      :pathName="$route.name"
      class="table-row"
    >
      <template slot-scope="{ item, index }">
        <td class="text-sm-center">
          <v-avatar size="40" style="background-color: #444">
            <v-img
              @click="showImagePreview(item.icon)"
              class="hover-pointer"
              aspect-ratio="1"
              :src="
                item.icon ? item.icon.path : require('@/assets/imgs/user.png')
              "
            ></v-img>
          </v-avatar>
        </td>
        <td class="text-sm-center">{{ item.name }}</td>
        <td class="toggle-spacing text-center">
          <toggle-service
            :is-edit="true"
            model-name="topics"
            :model-id="item.id"
            field="service"
            v-model="item.service"
            :validate="true"
          />
        </td>
        <td class="text-sm-center">
          <v-icon
            @click="handleEdit(item, index)"
            :title="$t('icon.edit')"
            small
            >mdi-pencil</v-icon
          >
          <v-icon
            @click="handleDelete(item, index)"
            :title="$t('icon.delete')"
            small
            >mdi-delete</v-icon
          >
        </td>
      </template>
      <!-- dilaog -->
      <template #wrraping_dialog="{ dialog }">
        <form-action
          :isEdit="isEdit"
          :dialog="dialog"
          :table_ref="$refs.table_ref"
          :item="item"
          :index="itemIndex"
          :responseName="responseName"
        />
      </template>
      <!-- dilaog -->
    </wrapping-table>
    <!-- table -->

    <!-- Image Preview -->
    <global-image-preview
      :showDialog="imageOverlay"
      :imagePath="currentPreviewImage"
      @closePreview="imageOverlay = false"
    />
    <!-- Image Preview -->
  </div>
</template>

<script>
export default {
  name: "GenericNameCompoenent",
  components: {
    FormAction: () => import("./components/FormAction"),
  },
  props: {
    responseName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      headers: ["photo", "name", "service", "actions"],
      isEdit: false,
      item: {},
      itemIndex: "",
      currentPreviewImage: "",
      imageOverlay: false,
      toggleQueries: {
        query: {
          service: "",
        },
      },
    };
  },
  methods: {
    showImagePreview(image) {
      if (image) {
        this.currentPreviewImage = image.path;
        this.imageOverlay = true;
      }
    },
    onDialogClose() {
      this.isEdit = false;
    },
    handleOpenDialog() {
      this.$refs.table_ref.toggleDialog();
    },

    handleDelete({ id }, index) {
      this.$refs.table_ref.handleDelete(id, index);
    },
    handleEdit(item, index) {
      this.isEdit = true;
      this.item = item;
      this.itemIndex = index;
      this.$refs.table_ref.toggleDialog();
    },
  },
};
</script>
